;jQuery(function ($) {
    var $body = $('body');

    common_modal($body, '.header__burger');
});

// модалка
function common_modal($body, linkSelector) {
    var $sideMenu = $body.find('.side-menu');

    $body.on('click', linkSelector, function () {
        open();
        return false;
    }).on('click', '.side-menu__close', function () {
        close();
        return false;
    });

    $sideMenu.click(function (e) {
        if ($(e.target).is($sideMenu)) {
            close();
            return false;
        }
    });

    var containerClass = 'side-menu__container';
    var openClass = 'side-menu__container_open';

    function open() {
        $sideMenu.fadeIn();
        $sideMenu.find('.' + containerClass).addClass(openClass);
        $body.css({overflow: 'hidden'});
    }

    function close() {
        $sideMenu.find('.' + containerClass).removeClass(openClass);
        $sideMenu.hide();
        $body.css({overflow: 'visible'});
    }
}
